// extracted by mini-css-extract-plugin
export default {"background":"Faq_background__N-hxR","body":"Faq_body__duNKl","title":"Faq_title__IbfIA","list":"Faq_list__W6wWy"};